var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddDeviceBtnMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 124.988,
    height: 107.952,
    viewBox: "0 0 124.988 107.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5800",
    "data-name": "Group 5800",
    transform: "translate(-1570.012 -936.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_67_6",
    "data-name": "Component 67 \\u2013 6",
    transform: "translate(1570.012 936.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_179",
    "data-name": "Polygon 179",
    d: "M59.286,0a9,9,0,0,1,7.808,4.524l16.34,28.5a9,9,0,0,1,0,8.953l-16.34,28.5A9,9,0,0,1,59.286,75H26.714a9,9,0,0,1-7.808-4.524l-16.34-28.5a9,9,0,0,1,0-8.953l16.34-28.5A9,9,0,0,1,26.714,0Z",
    transform: "translate(0 43) rotate(-30)",
    fill: "#ffd500"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5733",
    "data-name": "Group 5733",
    transform: "translate(1597.604 964.504)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_3930",
    "data-name": "Path 3930",
    transform: "translate(-193.639 -110.109)",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.346,128.067l-14.74,8.51V153.6l14.74,8.51,14.739-8.51V136.576Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 222.3461303710938 128.0665893554688 L 207.6066284179688 136.5761413574219 L 207.6066284179688 153.5953674316406 L 222.3461303710938 162.1050415039062 L 237.0856018066406 153.5953674316406 L 237.0856018066406 136.5761413574219 L 222.3461303710938 128.0665893554688 M 222.3461303710938 124.6025238037109 L 240.0856018066406 134.8440551757812 L 240.0856018066406 155.3274383544922 L 222.3461303710938 165.5691223144531 L 204.6066284179688 155.3274383544922 L 204.6066284179688 134.8440551757812 L 222.3461303710938 124.6025238037109 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_356",
    "data-name": "Line 356",
    y1: 8.586,
    x2: 14.872,
    transform: "translate(10.446 9.772)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_357",
    "data-name": "Line 357",
    y1: 11.612,
    x2: 20.113,
    transform: "translate(5.102 3.443)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_358",
    "data-name": "Line 358",
    y1: 14.834,
    x2: 25.693,
    transform: "translate(-1 -3.905)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_359",
    "data-name": "Line 359",
    x2: 14.872,
    y2: 8.586,
    transform: "translate(32.815 9.881)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_360",
    "data-name": "Line 360",
    x2: 20.113,
    y2: 11.612,
    transform: "translate(32.58 3.352)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_361",
    "data-name": "Line 361",
    x2: 25.693,
    y2: 14.834,
    transform: "translate(33.106 -4)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3932",
    "data-name": "Path 3932",
    d: "M217.785,128.067l-10.178,5.876V145.7l10.178,5.876,10.178-5.876V133.943Z",
    transform: "translate(-189.07 -104.406)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_327",
    "data-name": "Polygon 327",
    transform: "translate(1636 988)",
    fill: "#f7f7f7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.36594772338867 50 L 17.63404655456543 50 C 16.21089553833008 50 14.88414573669434 49.23471832275391 14.17156600952148 48.00281143188477 L 2.313726186752319 27.50280952453613 C 1.599156141281128 26.26742935180664 1.599156141281128 24.73257064819336 2.313726186752319 23.49719047546387 L 14.17157649993896 2.997189998626709 C 14.88414573669434 1.76528000831604 16.21089553833008 1 17.63405609130859 1 L 41.36594772338867 1 C 42.78910446166992 1 44.1158561706543 1.76528000831604 44.82842636108398 2.997189998626709 L 56.6862678527832 23.49719047546387 C 57.40084457397461 24.73257064819336 57.40084457397461 26.26742935180664 56.6862678527832 27.50280952453613 L 44.82842636108398 48.00281143188477 C 44.1158561706543 49.23471832275391 42.78910446166992 50 41.36594772338867 50 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17.63404846191406 2 C 16.56667709350586 2 15.57162857055664 2.573959350585938 15.03719711303711 3.497890472412109 L 3.179347991943359 23.99789047241211 C 2.643409729003906 24.92443084716797 2.643409729003906 26.07556915283203 3.179347991943359 27.00210952758789 L 15.03718948364258 47.50209808349609 C 15.57161712646484 48.42604064941406 16.56667709350586 49 17.63404846191406 49 L 41.36594772338867 49 C 42.43331909179688 49 43.42837905883789 48.42604064941406 43.96280670166016 47.50209808349609 L 55.82064819335938 27.00210952758789 C 56.35658645629883 26.07556915283203 56.35658645629883 24.92443084716797 55.82064819335938 23.99789047241211 L 43.96280670166016 3.497890472412109 C 43.42837905883789 2.573959350585938 42.43331909179688 2 41.36594772338867 2 L 17.63404846191406 2 M 17.63404846191406 0 L 41.36594772338867 0 C 43.15082931518555 0 44.80035781860352 0.9514617919921875 45.69404602050781 2.496490478515625 L 57.55188751220703 22.99649047851562 C 58.44775772094727 24.54528045654297 58.44775772094727 26.45471954345703 57.55188751220703 28.00350952148438 L 45.69404602050781 48.50350189208984 C 44.80035781860352 50.04853820800781 43.15082931518555 51 41.36594772338867 51 L 17.63404846191406 51 C 15.84916687011719 51 14.19963836669922 50.04853820800781 13.30594635009766 48.50350189208984 L 1.448108673095703 28.00350952148438 C 0.5522384643554688 26.45471954345703 0.5522384643554688 24.54528045654297 1.448108673095703 22.99649047851562 L 13.30595779418945 2.496490478515625 C 14.19964981079102 0.9514617919921875 15.84917831420898 0 17.63404846191406 0 Z",
    stroke: "none",
    fill: "#545454"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon_navigation_close_24px",
    "data-name": "icon/navigation/close_24px",
    transform: "translate(1649 998)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 33,
    height: 33,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Color",
    "data-name": " \\u21B3Color",
    d: "M20.364,2.051,18.313,0,10.182,8.131,2.051,0,0,2.051l8.131,8.131L0,18.313l2.051,2.051,8.131-8.131,8.131,8.131,2.051-2.051-8.131-8.131Z",
    transform: "translate(16.5 2.101) rotate(45)",
    fill: "#787878"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDeviceBtnMobile);
export default __webpack_public_path__ + "static/media/addDeviceBtnMobile.a47dd6f3617d576960639e992046f3ed.svg";
export { ForwardRef as ReactComponent };